import React from 'react';
import {
  Typography,
  message,
  Button,
} from 'antd';
import { getIntl } from '@/utils/intl';

const intl = getIntl();
export type CopyButtonProps = {
  buttonText: any;
  buttonType?: string;
  copyText: string;
}
const CopyButton: React.FC<CopyButtonProps> = ({ buttonText,copyText, buttonType = 'button'}) => {
  return (
    <Typography.Text
      className='inline-block mr-xs'
      copyable={{
        icon: [
          buttonType == 'button' ?
            <Button key="copyBefore" disabled={!copyText}>
              {buttonText}
            </Button>
            : <a key="copyBefore">{buttonText}</a>,
          buttonType == 'button' ?<Button key="copyAfter" disabled={!copyText}>
            {buttonText}
          </Button>
            : <a key="copyAfter">{buttonText}</a>
        ],
        text: copyText,
        tooltips:false,
        onCopy: () => {
          message.success(intl.formatMessage({ defaultMessage: '复制成功' }));
        }
      }}>
    </Typography.Text>
  );
};

CopyButton.defaultProps = {
  buttonText: intl.formatMessage({ defaultMessage: '复制' }),
};

export default CopyButton;
